import React from "react";
import Dropbox from "../../../../../../components/svgs/Dropbox";
import SharePoint from "../../../../../../components/svgs/SharePoint";
import GoogleDrive from "../../../../../../components/svgs/GoogleDrive";
import { hasAllDataRepoPermission } from "../../../../../../utils";
import FilingAssistantMenu from "./FilingAssistantMenu";

export default function HeaderActions({
    tab,
    isFAMenuVisible,
    setFAMenuVisible,
    company,
    user,
    localModule,
    isDataRepository,
    dataRoomMenuVisible,
    setDataRoomMenuVisible,
    syncing,
    syncApiBase,
    onConnectDataRoom,
    syncDrive,
    syncDropbox,
    reverseSyncDropbox,
    syncSharePoint,
    reSyncSharePoint,
    handleDisconnectDataRoom,
    onAccurateFileName,
    onAccurateFolderName,
    onClickFileReportHistory,
    onClickViewUnallocatedFiles,
    checkDuplicatedFiles,
    onClickDeduperReportHistory,
}) {
    if (tab === "kitemark") {
        return (
            <>
                <span className="shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic">Kitemark Audit</span>
                <span className="shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic">Kitemark Report</span>
                <span className="shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic">Digital Certificate</span>
                <span className="shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic">Full Report</span>
                <span className="shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic">Report by Section</span>
            </>
        );
    }

    // For module tabs (non-repository), show a simplified Filing Assistant with import buttons
    if (localModule && !isDataRepository) {
        return (
            <div className="pr df jce aifs">
                <div className="menuHover pr h100">
                    <button onMouseEnter={() => setFAMenuVisible(true)} className="w200px btn-filing-assistant bg3 bg4-hover c1 td250 br50px px1rem py0-5rem h100 fw600 cp ttc bsbb tac df jcc aic fs13px">
                        Filing Assistant
                    </button>
                    <FilingAssistantMenu
                        company={company}
                        isVisible={isFAMenuVisible}
                        onAccurateFileName={onAccurateFileName}
                        onAccurateFolderName={onAccurateFolderName}
                        onClickFileReportHistory={onClickFileReportHistory}
                        onClickViewUnallocatedFiles={onClickViewUnallocatedFiles}
                        checkDuplicatedFiles={checkDuplicatedFiles}
                        onClickDeduperReportHistory={onClickDeduperReportHistory}
                    />
                </div>
            </div>
        );
    }

    if (!(localModule && isDataRepository)) return null;

    const syncLink = company.gDriveLink || company.sharePointLink || company.dropBoxLink;
    const allFiles = [];
    const sections = localModule?.sections ?? [];
    for (const sec of sections) {
        const questions = sec?.questions ?? [];
        for (const ques of questions) {
            const files = ques?.answer?.files ?? [];
            if (files.length > 0) allFiles.push(...files);
        }
    }

    let syncRequired = false;
    if (company.dropBoxFolderMetadata) {
        syncRequired = allFiles.some((file) => !file?.dbFileMetadata);
    }
    if (company.sharePointLink) {
        syncRequired = allFiles.some((file) => !file?.spDriveItem);
    }

    const disableSyncButton = syncRequired !== true;
    const isMember = company?.members?.some((member) => member._id === user._id);
    const hasAllPermissions = company ? hasAllDataRepoPermission(company?.memberPermissions?.[user._id]) : false;
    const isInvestorOwner = company?.investors && Object.keys(company.investors).length > 0 && company.investors[user._id] && hasAllDataRepoPermission(company?.investors?.[user._id]?.modules);
    const canManageDataRoom = ((!company?.isParent && company?.owners?.[0] === user._id) || (company?.isParent && company?.owners?.[0] === user._id) || ((company?.servicedBy?._id || company?.servicedBy) === user._id) || (isMember && hasAllPermissions) || isInvestorOwner);
    const openWindow = (url) => window.open(url, "_blank");

    return (
        <>
            {canManageDataRoom ? (
                <div className="pr menuHover1">
                    {tab === "repository" &&
                        (!syncLink ? (
                            <button
                                onClick={() => onConnectDataRoom(syncApiBase)}
                                className={`${!company.uploadedFile && "op20 pen "} fs13px bg3 bg4-hover c1 td250 br50px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic`}
                            >
                                Connect Data Room
                            </button>
                        ) : (
                            <button
                                onMouseEnter={() => setDataRoomMenuVisible(true)}
                                className="w200px btn-filing-assistant bg3 bg4-hover c1 td250 br50px px1rem py0-5rem h100 fw600 cp ttc bsbb tac df jcc aic fs13px pr"
                            >
                                Data Room
                            </button>
                        ))}

                    {company.gDriveLink && dataRoomMenuVisible ? (
                        <div className="menu1 shadow df fdc pa bg1 zi10 w200px">
                            <button className={`${company.syncRequired ? "bg4 bg3-hover " : "bg3 bg4-hover "} c3 td200 px1rem py0-5rem fw400 c4-hover cp ttc bsbb tal df jcfs aic fs15px ${syncing && "op60 cnd"}`} disabled={syncing} onClick={syncDrive}>
                                <GoogleDrive className="pen mr1rem dataroomIcon" />
                                Sync Data room
                            </button>
                            {company.folderId ? (
                                <button className={`c3 td200 px1rem py0-5rem fw400 c4-hover cp ttc bsbb tal df jcfs aic fs15px ${syncing && "op60 cnd"}`} disabled={syncing} onClick={() => openWindow(`https://drive.google.com/drive/folders/${company.folderId}`)}>
                                    <GoogleDrive className="pen mr1rem dataroomIcon" />
                                    View Data Room
                                </button>
                            ) : null}
                            <button disabled={syncing} onClick={() => handleDisconnectDataRoom("gdrive")} className={`c3 td200 px1rem py0-5rem fw400 c4-hover cp ttc bsbb tal df jcfs aic fs15px ${syncing && "op60 cnd"}`}>
                                <GoogleDrive className="pen mr1rem dataroomIcon" />
                                Disconnect
                            </button>
                        </div>
                    ) : null}

                    {company.dropBoxLink && dataRoomMenuVisible ? (
                        <div className="menu1 shadow df fdc pa bg1 zi10 w200px">
                            <button disabled={syncing || disableSyncButton} className={`${company.syncRequired || syncRequired ? "op100" : "op60"} c3 td200 px1rem py0-5rem fw400 c4-hover cp ttc bsbb tal df jcfs aic fs15px ${(syncing || disableSyncButton) && "op60 cnd"}`} onClick={syncDropbox}>
                                <Dropbox className="pen mr1rem dataroomIcon" />
                                Sync
                            </button>
                            <button disabled={syncing || company.syncRequired || syncRequired} className={`c3 td200 px1rem py0-5rem fw400 c4-hover cp ttc bsbb tal df jcfs aic fs15px ${(syncing || company.syncRequired || syncRequired) && "op60 cnd"}`} onClick={reverseSyncDropbox}>
                                <Dropbox className="pen mr1rem dataroomIcon" />
                                Reverse Sync
                            </button>
                            {company.dropBoxFolderMetadata ? (
                                <button disabled={syncing} className={`c3 td200 px1rem py0-5rem fw400 c4-hover cp ttc bsbb tal df jcfs aic fs15px ${syncing && "op60 cnd"}`} onClick={() => openWindow(`https://dropbox.com/home/${company.dropBoxFolderMetadata.path_display}`)}>
                                    <Dropbox className="pen mr1rem dataroomIcon" />
                                    View Dataroom
                                </button>
                            ) : null}
                            <button disabled={syncing} onClick={() => handleDisconnectDataRoom("dropbox")} className={`c3 td200 px1rem py0-5rem fw400 c4-hover cp ttc bsbb tal df jcfs aic fs15px ${syncing && "op60 cnd"}`}>
                                <Dropbox className="pen mr1rem dataroomIcon" />
                                Disconnect
                            </button>
                        </div>
                    ) : null}

                    {company.sharePointLink && dataRoomMenuVisible ? (
                        <div className="menu1 shadow df fdc pa bg1 zi10 w200px" onMouseEnter={() => setDataRoomMenuVisible(true)}>
                            <button disabled={syncing || disableSyncButton} className={`${company.syncRequired || syncRequired ? "bg4 bg3-hover " : "bg3 bg4-hover "} c3 td200 px1rem py0-5rem fw400 c4-hover cp ttc bsbb tal df jcfs aic fs15px ${(syncing || disableSyncButton) && "op60 cnd"}`} onClick={syncSharePoint}>
                                <SharePoint className="pen mr1rem dataroomIcon" />
                                Sync
                            </button>
                            <button disabled={syncing || company.syncRequired || syncRequired} className={`c3 td200 px1rem py0-5rem fw400 c4-hover cp ttc bsbb tal df jcfs aic fs15px ${(syncing || company.syncRequired || syncRequired) && "op60 cnd"}`} onClick={reSyncSharePoint}>
                                <SharePoint className="pen mr1rem dataroomIcon" />
                                Reverse Sync
                            </button>
                            {company.sharePointLink ? (
                                <button disabled={syncing} className={`c3 td200 px1rem py0-5rem fw400 c4-hover cp ttc bsbb tal df jcfs aic fs15px ${syncing && "op60 cnd"}`} onClick={() => openWindow(`${company.sharePointFolderDriveItem.rootFolder.webUrl}`)}>
                                    <SharePoint className="pen mr1rem dataroomIcon" />
                                    View Data Room
                                </button>
                            ) : null}
                            <button disabled={syncing} onClick={() => handleDisconnectDataRoom("sharepoint")} className={`c3 td200 px1rem py0-5rem fw400 c4-hover cp ttc bsbb tal df jcfs aic fs15px ${syncing && "op60 cnd"}`}>
                                <SharePoint className="pen mr1rem dataroomIcon" />
                                Disconnect
                            </button>
                        </div>
                    ) : null}
                </div>
            ) : (
                <div></div>
            )}

            {tab === "repository" ? (
                <div className="pr df jce aifs">
                    <div className="menuHover pr h100">
                        <button onMouseEnter={() => setFAMenuVisible(true)} className="w200px btn-filing-assistant bg3 bg4-hover c1 td250 br50px px1rem py0-5rem h100 fw600 cp ttc bsbb tac df jcc aic fs13px">
                            <span className="tooltip-area" style={{ top: "0px", left: "0px" }}>
                                <i className="icon pr">
                                    <img className="h3rem" src={require("../../../../../../../images/info-icon.svg")} alt="info-icon" />
                                    <div className="overlay-box withGirl"></div>
                                </i>
                            </span>
                            Filing Assistant
                        </button>
                        <FilingAssistantMenu
                            company={company}
                            isVisible={isFAMenuVisible}
                            onAccurateFileName={onAccurateFileName}
                            onAccurateFolderName={onAccurateFolderName}
                            onClickFileReportHistory={onClickFileReportHistory}
                            onClickViewUnallocatedFiles={onClickViewUnallocatedFiles}
                            checkDuplicatedFiles={checkDuplicatedFiles}
                            onClickDeduperReportHistory={onClickDeduperReportHistory}
                        />
                    </div>
                </div>
            ) : null}
        </>
    );
}
